import { ApolloError } from "@apollo/client";

import { CheckIntoShiftMutation } from "../shared/components/VolunteerShiftModal/graphql/checkIntoShift.generated";

export const LATE_CHECK_IN_GRACE_MINUTES = 60;

export type TShift = {
  id: number;
  name: string;
  startTime: Date;
  endTime: Date;
  /** Effective end including buffer when applicable. */
  displayEndTime: Date;
  hasBuffer: boolean;
};

export type TShiftEligibility = "eligible" | "checked-in" | "too-late";

export type TAssignedShift = TShift & {
  eligibility: TShiftEligibility;
};

export type TVolunteer = {
  eventAttendeeId: number;
  name: string;
  legalName: string;
  email: string;
  primaryRole: string;
  notes: string;
};

export type TScanStatusColor =
  | "primary-light"
  | "success-light"
  | "warning-light"
  | "danger-light"
  | "secondary-light";

export type TVolunteerScanStatus = {
  label: string;
  color: TScanStatusColor;
  hours: number;
};

export type TCheckInResult =
  | {
      success: boolean;
      data: CheckIntoShiftMutation | null | undefined;
      error?: ApolloError;
    }
  | {
      success: boolean;
      error: ApolloError;
      data?: undefined;
    };

export type TRelativeTone = "now" | "soon" | "later" | "past";

export type TRelativeTime = {
  text: string;
  tone: TRelativeTone;
};
